module.exports = __webpack_public_path__ + "img/interface OneB Mapper_6.80d7e154.jpg";